import { BaseDefaultTheme } from 'styled-components';

const base: BaseDefaultTheme = {};

export default base;
